// Transitional shim for `packages/shared/`, which still imports Gql-prefixed
// types from `types/graphql`. Delete this file once shared migrates off
// `types/graphql`.
//
// Marketplace code MUST import from `src/gql/graphql` directly. An ESLint
// no-restricted-imports rule enforces this.

import type {
  LibraryProduct,
  Dispensaries,
  Specials,
  ImageBanner,
  ProductPotency,
  Products,
  Products_Images,
  Products_Terpene,
  Products_CannabinoidV2,
  LibraryProductCannabinoidsInputV2,
  LibraryProductTerpenesInput,
  WeeklyHours,
  SpecialHours,
  ReservationOptionsForOrderType,
} from 'src/gql/graphql';

export * from 'src/gql/graphql';

export type GqlLibraryProduct = LibraryProduct;
export type GqlDispensaries = Dispensaries;
export type GqlSpecials = Specials;
export type GqlImageBanner = ImageBanner;
export type GqlProductPotency = ProductPotency;
export type GqlProducts = Products;
export type GqlProducts_Images = Products_Images;
export type GqlProducts_Terpene = Products_Terpene;
export type GqlProducts_CannabinoidV2 = Products_CannabinoidV2;
export type GqlLibraryProductCannabinoidsInputV2 = LibraryProductCannabinoidsInputV2;
export type GqlLibraryProductTerpenesInput = LibraryProductTerpenesInput;
export type GqlWeeklyHours = WeeklyHours;
export type GqlSpecialHours = SpecialHours;
export type GqlReservationOptionsForOrderType = ReservationOptionsForOrderType;
